import React from 'react';
import * as BS from 'react-bootstrap';
import * as BSEx from '../../BootstrapExtends';
import PropTypes from 'prop-types';
import Panel from '../../../models/SpreadsheetReportConfigs/Panel';
import { StringContentVariableOptions } from '../../../enums/SpreadsheetReportConfigs';
import SpreadsheetReportConfigs from '../../../models/SpreadsheetReportConfigs/index.js';
import PreviewOutputStringDataModal from '../Modal/PreviewOutputStringDataModal';

const propTypes = {
  updatedSpreadsheetReportConfigs: PropTypes.shape(
    SpreadsheetReportConfigs.propTypes
  ),
  panel: PropTypes.exact(Panel.propTypes),
  errors: PropTypes.object.isRequired,
  touched: PropTypes.instanceOf(Object),
  onEventChange: PropTypes.func,
  onValueChange: PropTypes.func,
  onBlur: PropTypes.func,
};

const scope =
  'frontend.components.SpreadsheetReportConfigs.Form.CustomReportForm.sheetConfigSection.panelSection';

const CustomReportStringPanel = ({
  updatedSpreadsheetReportConfigs,
  panel,
  errors,
  touched,
  onEventChange,
  onValueChange,
  onBlur,
}) => {
  const addVariableToContent = (variable) => {
    const newContent = panel.content + variable;
    onValueChange('content')(newContent);
  };

  return (
    <>
      <BSEx.FormGroupInline
        label={I18n.t(`${scope}.field.content.label`)}
        error={errors.content}
        touched={touched.content}
      >
        <BS.ButtonToolbar
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            rowGap: '5px',
            marginBottom: '15px',
          }}
        >
          {Object.entries(StringContentVariableOptions).map(([key, option]) => (
            <BS.Button
              key={key}
              bsStyle='default'
              onClick={() => addVariableToContent(option.value)}
            >
              {option.label}
            </BS.Button>
          ))}
        </BS.ButtonToolbar>

        <BS.FormControl
          type='text'
          value={panel.content}
          onChange={onEventChange('content')}
          onBlur={() => onBlur('content')}
        />
      </BSEx.FormGroupInline>

      <PreviewOutputStringDataModal
        content={panel.content}
        period={updatedSpreadsheetReportConfigs.period}
        startDate={updatedSpreadsheetReportConfigs.startDate}
        endDate={updatedSpreadsheetReportConfigs.endDate}
      />
    </>
  );
};

CustomReportStringPanel.propTypes = propTypes;

export default CustomReportStringPanel;
